import config from '@plone/registry';
import minilogo from '@redturtle/qubicaamf-theme/assets/qubicaminilogo.png';
import cx from 'classnames';
import { NavLink } from 'react-router-dom';
import styles from './styles.module.css';
import InstagramSVG from '@redturtle/qubicaamf-theme/components/Icons/InstagramSVG';
import FacebookSVG from '@redturtle/qubicaamf-theme/components/Icons/FacebookSVG';
import YoutubeSVG from '@redturtle/qubicaamf-theme/components/Icons/YoutubeSVG';
import LinkedInSVG from '@redturtle/qubicaamf-theme/components/Icons/LinkedInSVG';

export default function FooterLinks() {
  const Image = config.getComponent('Image').component;
  return (
    <section className={styles.footer_links}>
      <div className={cx(styles.footer_column, styles.mainlocale)}>
        <div className={cx(styles.logo)}>
          <NavLink to="/">
            <Image src={minilogo} alt="Qubica AMF Logo" />
          </NavLink>
        </div>
        <div className={cx(styles.innercolumn)}>
          <div className={styles.eulocale}>
            <h4 className={cx(styles.section_title, styles.h4)}>
              Headquarters Europe
            </h4>
            <p>QubicaAMF Europe Spa</p>
            <p>Via della Croce Coperta 15</p>
            <p>40128 Bologna - Italy</p>
            <p>Ph. +39.0514192611</p>
            <p>Fax. +39.0514192602</p>
            <p>P.I IT04320910377</p>
          </div>
          <div className={styles.uslocale}>
            <h4 className={styles.h4}>U.S. Headquarters</h4>
            <p>QubicaAMF Worldwide LLC</p>
            <p>8100 AMF Drive</p>
            <p>Mechanicsville, VA 23111-USA</p>
            <p>Ph. (804) 569-1000</p>
            <p>866-460-QAMF (7263)</p>
            <p>Fax. (804) 559-8650</p>
          </div>
        </div>
      </div>
      <div className={cx(styles.footer_column, styles.about)}>
        <div className={cx(styles.innercolumn)}>
          <h4 className={styles.h4}>About QubicaAMF</h4>
          <ul>
            <li>
              <NavLink to="/company">Company</NavLink>
            </li>
            <li>
              <a href="https://careers.qubicaamf.com/">Careers</a>
            </li>
            <li>
              <NavLink to="/contact/find-your-local-representative">
                Around the World
              </NavLink>
            </li>
            <li>
              <NavLink to="/news">Newsroom</NavLink>
            </li>
          </ul>
        </div>
      </div>
      <div className={cx(styles.footer_column, styles.solution)}>
        <div className={cx(styles.innercolumn)}>
          <h4 className={styles.h4}>Solutions</h4>
          <ul>
            <li>
              <NavLink to="/products">Products</NavLink>
            </li>
            <li>
              <NavLink to="/services">Services</NavLink>
            </li>
            <li>
              <NavLink to="/support">Support</NavLink>
            </li>
          </ul>
        </div>
      </div>
      <div className={cx(styles.footer_column, styles.get_in_touch)}>
        <div className={cx(styles.innercolumn)}>
          <div className={styles.get_in_touch}>
            <h4 className={styles.h4}>Get in Touch</h4>
            <div className={styles.contact_us}>
              <NavLink to="/contact">Contact Us</NavLink>
            </div>
          </div>
          <div className={styles.social_media}>
            <h4 className={styles.h4}>Social Media</h4>
            <div className={styles.social_items}>
              <a href="https://www.facebook.com/pages/QubicaAMF-Worldwide/110600722306404">
                <FacebookSVG aria-label="Qubica AMF Facebook" />
              </a>
              <a href="https://www.youtube.com/QubicaAMFWorldwide">
                <YoutubeSVG aria-label="Qubica AMF YouTube" />
              </a>
              <a href="https://www.linkedin.com/company/qubicaamf/">
                <LinkedInSVG aria-label="Qubica AMF LinkedIn" />
              </a>
              <a href="https://www.instagram.com/qubicaamfbowling/">
                <InstagramSVG aria-label="Qubica AMF Instagram" />
              </a>
            </div>
          </div>
          <div className={styles.newsletter}>
            <h4 className={styles.h4}>Newsletter</h4>
            <p>
              Subscribe to our
              <br />
              <a
                target="_blank"
                href="https://assets-usa.mkt.dynamics.com/33b40711-77ca-ed11-aece-000d3a13210f/digitalassets/standaloneforms/27eb7437-6da6-ef11-8a69-6045bdd97539"
                rel="noreferrer"
              >
                newsletter
              </a>{' '}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
